import { SelectionCard, SelectionCardGroup } from '@change/ds-forms';

import { NewCreditCard } from '../components/NewCreditCard';
import { PaypalButton } from '../components/PaypalButton';
import { SavedPaymentMethodSlot } from '../components/SavedPaymentMethodSlot';
import { SelectNewCardButton } from '../components/SelectNewCardButton';
import { StripeWalletWrapper } from '../components/StripeWalletWrapper';
import { SubmitButtonWrapper } from '../components/SubmitButtonWrapper';

import { useVariant1 } from './hooks/useVariant1';

export const Variant1 = () => {
	const {
		data: { savedPaymentMethods, selectedPaymentMethod },
		actions: { onSelectPaymentMethod },
	} = useVariant1();

	return (
		<div className="flex flex-col gap-3">
			<SelectionCardGroup
				label=""
				labelIsVisible={false}
				name="savedPaymentMethods"
				value={selectedPaymentMethod}
				onChange={onSelectPaymentMethod}
				colorVariant="blue"
				data-qa="saved-payment-methods"
			>
				{savedPaymentMethods.map((pm, index) => (
					<SelectionCard
						key={pm.type}
						value={pm.type}
						// Always set a border to prevent size shift when selected/unselected.
						// Border transition disabled by removing transition-[border-color,box-shadow]
						className="[&>div>div]:border-stroke-inverse-strong [&>div>div]:hover:border-background-overlay [&>div>div]:transition-none"
						data-qa={`saved-payment-method-${pm.type}`}
						slot={<SavedPaymentMethodSlot paymentMethod={pm} index={index} />}
					/>
				))}
			</SelectionCardGroup>
			<SelectNewCardButton
				selectedPaymentMethod={selectedPaymentMethod}
				onSelectPaymentMethod={onSelectPaymentMethod}
			/>
			<NewCreditCard selectedPaymentMethod={selectedPaymentMethod} />
			<PaypalButton selectedPaymentMethod={selectedPaymentMethod} />
			<StripeWalletWrapper selectedPaymentMethod={selectedPaymentMethod} />
			<SubmitButtonWrapper selectedPaymentMethod={selectedPaymentMethod} />
		</div>
	);
};
